import { render, staticRenderFns } from "./IDownTriangle.vue?vue&type=template&id=765fbee6&scoped=true&"
import script from "./IDownTriangle.vue?vue&type=script&lang=js&"
export * from "./IDownTriangle.vue?vue&type=script&lang=js&"
import style0 from "./IDownTriangle.vue?vue&type=style&index=0&id=765fbee6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765fbee6",
  null
  
)

export default component.exports